import { Component, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { tap, catchError, of, EMPTY } from 'rxjs';
import { LoginResponse } from 'src/app/core-module/models/login-response';
import { AuthService } from 'src/app/core-module/services/auth.service';
import { DashboardService } from 'src/app/core-module/services/dashboard.service';
import { UtilService } from 'src/app/core-module/services/util.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent {

  signInAllowed:boolean = true;
  errorText:string = "";
  username:string = "";
  password:string = "";
  public showForgotPassword: boolean = false;
  public email: string = "";
  public resetClicked: boolean = false;
  public resetEmailSent: boolean = false;
  public resetErrorMessage: boolean = false;
  public isBluebird: boolean = false;

  @ViewChild("usernameElement") usernameElement!: ElementRef;

  constructor(
    public authservice: AuthService,
    public router: Router,
    private dashboardService: DashboardService,
    private utils: UtilService
  ) {}

  ngOnInit(){
    if (environment.blueBird){
      this.isBluebird = true;
    }
    if (!this.utils.isOnline) {
      if (this.authservice.isLoggedInOffline()) {
        this.router.navigate(['home']);
      }
      return;
    }
    this.authservice.isLoggedIn().subscribe({
      next: (result: any) => {
        if (result?.status === 200) {
          this.navigateToLandingPage();
        }
      },
      error: () => {
        // An unauthenticated visitor should remain on the login page.
      }
    });
  }

  checkLogin(event: KeyboardEvent){
    if (event.key == "Enter"){
      this.doLogin();
    }
  }

  login():void{
    this.doLogin();
  }
  openLegacyLogin(){
    window.location.href = 'https://careaudits.co.uk/legacylogin';
  }

  private doLogin(): void{
    this.errorText = "";
    this.signInAllowed = false;
    this.authservice.login(this.username,this.password).pipe(
      tap((res:any) => {
        if (!res.body?.IsError){
          this.navigateToLandingPage();
        } else {
          this.resetOnError();
        }
        this.signInAllowed = true;
      }),
      catchError((err:any) => {
        this.resetOnError();
        return of(new LoginResponse());
      })
    ).subscribe();
  }

  private navigateToLandingPage(): void {
    this.dashboardService.getLandingRoute(true).subscribe(route => this.router.navigate([route]));
  }

  private resetOnError(): void{
    this.username = "";
    this.password = "";
    this.usernameElement.nativeElement.focus();
    this.errorText = "Username/password not recognized.";
    this.signInAllowed = true;
  }

  public showForgot(){
    this.showForgotPassword = true;
  }

  public showLogin(){
    this.showForgotPassword = false;
    this.resetErrorMessage = false;
    this.resetClicked = false;
    this.resetEmailSent = false;
  }

  public resetPassword(){
    this.resetClicked = true;
    this.resetErrorMessage = false;
    this.resetEmailSent = false;

    this.authservice.resetPassword(this.email).pipe(
      tap((res:any) =>
        {
          if (!res.body!.IsError){
            this.resetEmailSent = true;
            this.email = '';
          } else {
            this.resetErrorMessage = true;    
          }
          this.resetClicked = false;
        }
      ),
      catchError((err:any, n:any) => {
        this.resetErrorMessage = true;    
        this.resetClicked = false;
        return EMPTY;
      })
    ).subscribe();

    
  }

}
